import {
    GET_CHANGE_HISTORY_LIST,
    GET_CHANGE_HISTORY_DETAIL,
} from "../constants/constants";
import { instance } from "./apiRequest";

let _ChangeHistoryService = {
    async getChangeHistoryList({
        startDate = null,
        endDate = null,
        moduleName = null,
        actionType = null,
        changedByName = null,
        searchTerm = null,
        pageIndex = 1,
        pageSize = 10,
        sortBy = "ChangeDate",
        sortAsc = false,
    }) {
        return await instance.post(GET_CHANGE_HISTORY_LIST, {
            startDate,
            endDate,
            moduleName,
            actionType,
            changedByName,
            searchTerm,
            pageIndex,
            pageSize,
            sortBy,
            sortAsc,
        });
    },
    async getChangeHistoryDetail(id) {
        return await instance.post(GET_CHANGE_HISTORY_DETAIL, { id });
    },
};

export default _ChangeHistoryService;
